import React, { createContext, useContext, useState } from 'react';

export type ActionTypes = 'deduction';

export const WAREHOUSE_CARD_ACTIONS: Array<ActionTypes | undefined> = [undefined, 'deduction'];

interface ContextProps {
    currentAction?: ActionTypes;
    setCurrentAction: React.Dispatch<React.SetStateAction<ActionTypes | undefined>>;
    availableActions: Array<ActionTypes | undefined>;
    setSelectedCardIds: (selectedCardIds: string[]) => void;
    selectedCardIds: string[];
}

const defaultState = {
    currentAction: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setCurrentAction: () => {},
    availableActions: WAREHOUSE_CARD_ACTIONS,
    selectedCardIds: [],
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setSelectedCardIds: () => {},
};

const WarehouseCardActionContext = createContext<ContextProps>(defaultState);

const WarehouseCardActionProvider: React.FC= ({ children }) => {
    const [currentAction, setCurrentAction] = useState<ActionTypes | undefined>(undefined);
    const [selectedCardIds, setSelectedCardIds] = React.useState<string[]>([]);

    const warehouseActionContext = {
        currentAction,
        setCurrentAction,
        availableActions: WAREHOUSE_CARD_ACTIONS,
        selectedCardIds,
        setSelectedCardIds,
    };

    return (
        <WarehouseCardActionContext.Provider value={warehouseActionContext}>
            {children}
        </WarehouseCardActionContext.Provider>
    );
};

export const useWarehouseCardAction = () => {
    return useContext(WarehouseCardActionContext);
};

export default WarehouseCardActionProvider;